<template>
  <div id="tax-summary" class="table-responsive">
    <table class="table table-sm table-hover table-bordered">
      <tr>
        <th style="min-width: 150px">Tax Summary Item</th>
        <th class="text-end">
          <strong>{{ currentPayYear - 1 }}</strong>
        </th>
        <th class="text-end">
          <strong>{{ currentPayYear }}</strong>
        </th>
      </tr>
      <tr>
        <td>
          <strong>1. Gross assessed value of property</strong>
        </td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td class="ps-4">
          1a. Gross assessed value of land and improvements
        </td>
        <td class="text-end">
          {{ item.FirstYearGrossAVHomestead | currency(false) }}
        </td>
        <td class="text-end">
          {{ item.SecondYearGrossAVHomestead | currency(false) }}
        </td>
      </tr>
      <tr>
        <td class="ps-4">
          1b. Gross assessed value of all other residential property
        </td>
        <td class="text-end">
          {{ item.FirstYearGrossAVOtherResidential | currency(false) }}
        </td>
        <td class="text-end">
          {{ item.SecondYearGrossAVOtherResidential | currency(false) }}
        </td>
      </tr>
      <tr>
        <td class="ps-4">
          1c. Gross assessed value of all other property
        </td>
        <td class="text-end">
          {{ item.FirstYearGrossAVAllOther | currency(false) }}
        </td>
        <td class="text-end">
          {{ item.SecondYearGrossAVAllOther | currency(false) }}
        </td>
      </tr>
      <tr>
        <td>
          <strong>2. Equals total gross assessed value of property</strong>
        </td>
        <td class="text-end">
          {{ item.FirstYearTotalGrossAV | currency(false) }}
        </td>
        <td class="text-end">
          {{ item.SecondYearTotalGrossAV | currency(false) }}
        </td>
      </tr>
      <tr>
        <td class="ps-4">
          2a. Minus deductions
        </td>
        <td class="text-end">
          {{ item.FirstYearDeductions | currency(false) }}
        </td>
        <td class="text-end">
          {{ item.SecondYearDeductions | currency(false) }}
        </td>
      </tr>
      <tr>
        <td>
          <strong>3. Equals subtotal of net assessed value of property</strong>
        </td>
        <td class="text-end">
          {{ item.FirstYearTotalNetAV | currency(false) }}
        </td>
        <td class="text-end">
          {{ item.SecondYearTotalNetAV | currency(false) }}
        </td>
      </tr>
      <tr>
        <td class="ps-4">
          3a. Multiplied by your local tax rate
        </td>
        <td class="text-end">{{ item.FirstYearLocalTaxRate }}</td>
        <td class="text-end">
          {{ ltiDisplayRate === "T" ? item.SecondYearLocalTaxRate : "N/A" }}
        </td>
      </tr>
      <tr>
        <td>
          <strong>4. Equals gross tax liability</strong>
        </td>
        <td class="text-end">{{ item.FirstYearGrossTax | currency }}</td>
        <td class="text-end">{{ item.SecondYearGrossTax | currency }}</td>
      </tr>
      <tr>
        <td class="ps-4">
          4a. Minus local property tax credits
        </td>
        <td class="text-end">{{ item.FirstYearLocalTaxRelief | currency }}</td>
        <td class="text-end">{{ item.SecondYearLocalTaxRelief | currency }}</td>
      </tr>
      <tr>
        <td class="ps-4">
          4b. Minus savings due to property tax cap
        </td>
        <td class="text-end">{{ item.FirstYearPropertyTaxCap | currency }}</td>
        <td class="text-end">{{ item.SecondYearPropertyTaxCap | currency }}</td>
      </tr>
      <tr>
        <td class="ps-4">
          4c. Minus savings due to 65 years & older cap
        </td>
        <td class="text-end">{{ item.FirstYear65YearsOldCap | currency }}</td>
        <td class="text-end">{{ item.SecondYear65YearOldCap | currency }}</td>
      </tr>
      <tr>
        <td class="ps-4">
          4d. Minus savings due to county option circuit breaker credit
        </td>
        <td class="text-end">{{ item.FirstYearCountyOptionCap | currency }}</td>
        <td class="text-end">
          {{ item.SecondYearCountyOptionCap | currency }}
        </td>
      </tr>
      <tr>
        <td>
          <strong>5. Total property tax liability</strong>
        </td>
        <td class="text-end">{{ item.FirstYearTotalTax | currency }}</td>
        <td class="text-end">{{ item.SecondYearTotalTax | currency }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    latestPayYear() {
      if (this.item.DateOfNotice) {
        const mdy = this.item.DateOfNotice.split("/");
        return parseInt(mdy[2]);
      } else {
        return new Date().getFullYear();
      }
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    ltiDisplayRate: {
      type: String,
      default: null,
    },
    currentPayYear: {
      type: Number,
      default: null,
    },
  },
};
</script>
